import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'top',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_1.vue'),
      }],
    },
    {
      path: '/step01_1',
      name: 'step01_1',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_1.vue'),
      }],
    },
    {
      path: '/step01_2',
      name: 'step01_2',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_2.vue'),
      }],
    },
    {
      path: '/step01_3',
      name: 'step01_3',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_3.vue'),
      }],
    },
    {
      path: '/step01_4',
      name: 'step01_4',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_4.vue'),
      }],
    },
    {
      path: '/step01_5',
      name: 'step01_5',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/Step01_5.vue'),
      }],
    },
    {
      path: '/child_input',
      name: 'child_input',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/ChildInput.vue'),
      }],
    },
    {
      path: '/parent_input',
      name: 'parent_input',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/ParentInput.vue'),
      }],
    },
    {
      path: '/brother_input',
      name: 'brother_input',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/BrotherInput.vue'),
      }],
    },
    {
      path: '/none_input',
      name: 'none_input',
      component: () => import('./components/page/Step01.vue'),
      children: [{
        path: '',
        component: () => import('./components/page/NoneInput.vue'),
      }],
    },

    {
      path: '/step02',
      name: 'step02',
      component: () => import('./components/page/Step02.vue'),
    },

    {
      path: '/step03',
      name: 'step03',
      component: () => import('./components/page/Step03.vue'),
    },

    {
      path: '/mail',
      name: 'step04',
      component: () => import('./components/page/Step04.vue'),
    },
  ],
});
